import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { TokenStorageService } from '../../../modules/auth/services/token-storage.service';
import { Router } from '@angular/router';
import { User } from '../../../modules/auth/models/user.model';
import Swal from 'sweetalert2';
import { UserService } from '../../../modules/auth/services/user.service';
import { MotifreclamationService } from '../../../shared/services/motifreclamation';



@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit{

  
    role: string;
    isLoggedIn = false;
    showAdminBoard = false;
    showModeratorBoard = false;
    username: string;
    lastname: string;
  usertype: any;
  currentuser: any;
  nature: string;
  raisonsociale: string;
  indicatifagence: string;
  login: string;
  codebanque: string;
  id: string;
  motifsub: Subscription;
  currentdate: number;
  carte: String;
  affiliation: String;
  constructor(
    private router: Router,
              private Auth: TokenStorageService,
              private userservice: UserService,private mot: MotifreclamationService,
              ) { }
  ngOnInit() {
    this.motifsub = this.mot.motifreclamations$.subscribe(
      (motifs) => {
       // console.log(motifs[0].currentdate)
        motifs[0].currentdate?this.currentdate = motifs[0].currentdate:this.currentdate = new Date().getTime();
      }
    )
    this.isLoggedIn = !!this.Auth.getToken();
    if (this.isLoggedIn) {
      this.currentuser = this.Auth.getUser();
      console.log(this.currentuser)
      this.userservice.getUserById(this.currentuser.userId).then(
        (user:User)=>{
          this.role = user.role;
          this.usertype=user.usertype
          this.username = user.firstname;
          this.lastname= user.lastname;
          this.nature=user.nature
          this.raisonsociale=user.raisonsociale
          this.indicatifagence=user.indicatifagence
          this.codebanque=user.banque
          this.login=user.email
          this.id=user._id
          this.carte=user.carte
          this.affiliation=user.affiliation
        }
      )
      
    }
    this.mot.getmotifreclamationss()
  }
  returnprofil()
  {
    let profil=''
    if (this.role=='userbanque'&&this.usertype=='Metier')
    {
profil= 'metierbanque'
    }
    else if (this.role=='userbanque'&&this.usertype=='Clientpor'||this.role=='basic'&&this.usertype=='Clientpor')
    {
profil= 'porteur'
    }
    else if (this.role=='userbanque'&&this.usertype=='Clientcomm'||this.role=='basic'&&this.usertype=='Clientcomm')
    {
profil= 'commercant'
    }
    else if (this.role=='userbanque'&&this.usertype=='Agence')
    {
profil= 'agence'
    }
    else if (this.role=='adminbanque')
    {
profil= 'adminbanque'
    }
    else if (this.role=='superadmin')
    {
profil= 'superadmin'
    }
    else if (this.usertype=='comite arbitrage')
    {
profil= 'comite'
    }
    return profil
  }
  logout(): void {
    Swal.fire({
      title: 'Vous êtes sur le point de se déconnecter, voulez vous continuer?',     
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Se Déconnecter',
      cancelButtonText: 'Annuler',
    }).then((result) => {
      if (result.value) {   
    this.Auth.signOut();
  //window.location.reload()
        }
      else{       
      }
    }).catch(() => {
      Swal.fire('opération non aboutie!');
    });
  }
}
